import { render, staticRenderFns } from "./SectionNavigationBar.vue?vue&type=template&id=785e67b6"
import script from "./SectionNavigationBar.vue?vue&type=script&lang=js"
export * from "./SectionNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports